import 'jquery';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/img-loader/img-loader';
import 'Bem/site/checkbox-accept/checkbox-accept';
import 'Bem/site/skeleton-load/skeleton-load';
import 'Bem/site/ajax-form/ajax-form';
import 'Lib/js-anchor-link/js-anchor-link';
import { onScreen } from 'Lib/on-screen/on-screen';
import { whiteLabel } from 'Lib/white-label/white-label';

window.whiteLabel = whiteLabel;

onScreen($('.sezon-skazok__screen'), ($el) => {
    $el.addClass('sezon-skazok__section_visible');
}, 200, 200, 1.6);

svgSpriteLoader('/landing/sezon-skazok/svg/sprite.svg?v=20180320');